import { render, staticRenderFns } from "./EventDocsUpload.modal.vue?vue&type=template&id=1c9ca56f&scoped=true&"
import script from "./EventDocsUpload.modal.vue?vue&type=script&lang=js&"
export * from "./EventDocsUpload.modal.vue?vue&type=script&lang=js&"
import style0 from "./EventDocsUpload.modal.vue?vue&type=style&index=0&id=1c9ca56f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ca56f",
  null
  
)

export default component.exports